import React, { forwardRef, InputHTMLAttributes } from 'react'

import LabelledField from 'components/LabelledField'
import styled from 'styled-components'

type Ref = ((instance: HTMLInputElement | null) => void) | React.RefObject<HTMLInputElement> | null | undefined

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label?: string,
  isRequired?: boolean,
  errorMessage?: string,
  className?: string,
  value?: string | number,
  onClear?: (event: React.MouseEvent<HTMLButtonElement>) => void,
}

const TextInput = forwardRef(({ label = '', type = 'text', isRequired = false, errorMessage, className, onClear, value, ...inputProps }: Props, ref: Ref) => {
  const id = label?.replace(' ', '_')

  return (
    <S.LabelledField {...{ id, label, isRequired, errorMessage, className }}>
      <S.Input role="textbox" type={type} {...{ id, ref, value, ...inputProps }} />
      {onClear && value && <S.ClearIcon label={label} className="icon-cancel-circle" onClick={onClear} />}
    </S.LabelledField>
  )
})

export default TextInput

const S = {
  LabelledField: styled(LabelledField)`
    position: relative;
  `,
  Input: styled.input`
    display: block;
    padding-right: 6%;
    margin-bottom: 0;
    height: 39px;
    width: 100%;
    border-radius: 5px;
  `,
  ClearIcon: styled.span.withConfig({
    shouldForwardProp: (prop) => !['label'].includes(prop)
  })<{ label?: string }>`
    position: absolute;
    top: ${props => props.label ? '38px' : '12px'};
    right: 8px;
  `
}
